var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCorrectGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6952 0.810122C16.1016 1.22362 16.1016 1.89403 15.6952 2.30753L5.98167 12.1899C5.57524 12.6034 4.91628 12.6034 4.50985 12.1899L0.30483 7.91177C-0.101602 7.49827 -0.101602 6.82786 0.30483 6.41436C0.711261 6.00087 1.37022 6.00087 1.77665 6.41436L5.24576 9.94377L14.2234 0.810122C14.6298 0.396626 15.2887 0.396626 15.6952 0.810122Z",
    fill: "#00B383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrectGreen);
export default __webpack_public_path__ + "static/media/IconCorrectGreen.59751b09ecae4fe1a3dea9db985e39ee.svg";
export { ForwardRef as ReactComponent };